import React, { useState } from "react";
import "../App.css";
import FormulaDisplay from "./FormulaDisplay";

// 错误边界组件
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('比对计算器错误:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 24, textAlign: 'center', color: 'red' }}>
          <h3>比对计算器出现错误</h3>
          <p>请刷新页面重试</p>
          <button 
            onClick={() => window.location.reload()} 
            style={{ padding: '8px 16px', background: '#1890ff', color: 'white', border: 'none', borderRadius: 4 }}
          >
            刷新页面
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

const items = [
  { label: "NMHC", value: "nmhc" },
  { label: "二氧化硫", value: "so2" },
  { label: "氮氧化物", value: "nox" },
  { label: "颗粒物", value: "pm" },
  { label: "氧气", value: "o2" },
  { label: "流速", value: "flow" },
  { label: "温度", value: "temp" },
  { label: "湿度", value: "humidity" },
];

const getUnit = (item) => {
  if (["nmhc", "so2", "nox", "pm"].includes(item)) return "mg/m³";
  if (["o2", "humidity"].includes(item)) return "%";
  if (item === "flow") return "m/s";
  if (item === "temp") return "℃";
  return "";
};

const getRowCount = (item) => (["nmhc", "so2", "nox", "o2"].includes(item) ? 9 : 5);

function calcAvg(arr) {
  const nums = arr.map(v => v === "" ? 0 : Number(v));
  const valid = arr.filter(v => v !== "").length;
  return valid ? (nums.reduce((a, b) => a + b, 0) / valid).toFixed(2) : "";
}

function getResultJudgement(item, refAvg, absErr, relErr, accu) {
  refAvg = Number(refAvg);
  absErr = Math.abs(Number(absErr));
  relErr = Math.abs(Number(relErr));
  accu = Math.abs(Number(accu));
  let result = "";
  let reason = "";
  if (item === "nmhc") {
    if (refAvg >= 500) {
      result = accu <= 35 ? "符合" : "不符合";
      reason = "参比法平均值≥500时，相对准确度（%）≤35";
    } else if (refAvg >= 50) {
      result = accu <= 40 ? "符合" : "不符合";
      reason = "50≤参比法平均值＜500时，相对准确度（%）≤40";
    } else {
      result = absErr <= 20 ? "符合" : "不符合";
      reason = "参比法平均值＜50时，绝对误差≤±20";
    }
  } else if (item === "so2") {
    if (refAvg >= 143) {
      result = absErr <= 57 ? "符合" : "不符合";
      reason = "143≤参比法平均值＜715时，绝对误差不超过±57";
    } else if (refAvg >= 57) {
      result = relErr <= 30 ? "符合" : "不符合";
      reason = "57≤参比法平均值＜143时，相对误差（%）不超过±30";
    } else {
      result = absErr <= 17 ? "符合" : "不符合";
      reason = "参比法平均值＜57时，绝对误差不超过±17";
    }
  } else if (item === "nox") {
    if (refAvg >= 103) {
      result = absErr <= 41 ? "符合" : "不符合";
      reason = "103≤参比法平均值<513时，绝对误差不超过±41";
    } else if (refAvg >= 41) {
      result = relErr <= 30 ? "符合" : "不符合";
      reason = "41≤参比法平均值<103时，相对误差（%）不超过±30";
    } else {
      result = absErr <= 12 ? "符合" : "不符合";
      reason = "参比法平均值＜41时，绝对误差不超过±12";
    }
  } else if (item === "pm") {
    if (refAvg > 200) {
      result = relErr <= 15 ? "符合" : "不符合";
      reason = "参比法平均值>200时，相对误差（%）不超过±15";
    } else if (refAvg > 100) {
      result = relErr <= 20 ? "符合" : "不符合";
      reason = "100＜参比法平均值≤200时，相对误差（%）不超过±20";
    } else if (refAvg > 50) {
      result = relErr <= 25 ? "符合" : "不符合";
      reason = "50＜参比法平均值≤100时，相对误差（%）不超过±25";
    } else if (refAvg > 20) {
      result = relErr <= 30 ? "符合" : "不符合";
      reason = "20＜参比法平均值≤50时，相对误差（%）不超过±30";
    } else if (refAvg > 10) {
      result = absErr <= 6 ? "符合" : "不符合";
      reason = "10＜参比法平均值≤20时，绝对误差不超过±6";
    } else {
      result = absErr <= 5 ? "符合" : "不符合";
      reason = "参比法平均值≤10时，绝对误差不超过±5";
    }
  } else if (item === "o2") {
    if (refAvg <= 5.0) {
      result = absErr <= 1.0 ? "符合" : "不符合";
      reason = "参比法平均值≤5.0时，绝对误差（%）≤±1.0";
    } else {
      // 这里只能给出提示，实际95%置信上限需统计方法
      result = relErr <= 15 ? "符合" : "不符合";
      reason = "参比法平均值＞5时，相对误差的95%置信上限（%）≤15（此处仅以相对误差代替）";
    }
  } else if (item === "temp") {
    result = absErr <= 3 ? "符合" : "不符合";
    reason = "温度，绝对误差不超过±3";
  } else if (item === "humidity") {
    if (refAvg > 5.0) {
      result = relErr <= 25 ? "符合" : "不符合";
      reason = "参比法平均值>5.0时，相对误差（%）不超过±25";
    } else {
      result = absErr <= 1.5 ? "符合" : "不符合";
      reason = "参比法平均值≤5.0时，绝对误差不超过±1.5";
    }
  } else if (item === "flow") {
    if (refAvg > 10) {
      result = relErr <= 10 ? "符合" : "不符合";
      reason = "参比法流速平均值大于10m/s时，相对误差在±10%以内";
    } else {
      result = relErr <= 12 ? "符合" : "不符合";
      reason = "参比法流速平均值小于等于10m/s时，相对误差在±12%以内";
    }
  }
  return { result, reason };
}

const ComparisonCalculator = () => {
  const [item, setItem] = useState("nmhc");
  const [refValues, setRefValues] = useState(Array(getRowCount("nmhc")).fill(""));
  const [cemsValues, setCemsValues] = useState(Array(getRowCount("nmhc")).fill(""));
  
  // 根据监测项目确定详细值数量
  const getDetailValueCount = (item) => ["o2", "so2", "nox"].includes(item) ? 5 : 3;
  const detailValueCount = getDetailValueCount(item);
  
  const [cemsDetailValues, setCemsDetailValues] = useState(
    Array(getRowCount("nmhc")).fill().map(() => Array(getDetailValueCount("nmhc")).fill(""))
  );

  // 添加错误边界处理
  const handleItemChange = (newItem) => {
    try {
      console.log('切换种类:', newItem);
      setItem(newItem);
    } catch (error) {
      console.error('切换种类时出错:', error);
      // 如果出错，回退到默认值
      setItem("nmhc");
    }
  };

  // 动态行数
  const rowCount = getRowCount(item);
  React.useEffect(() => {
    const newDetailValueCount = getDetailValueCount(item);
    setRefValues(Array(rowCount).fill(""));
    setCemsValues(Array(rowCount).fill(""));
    setCemsDetailValues(Array(rowCount).fill().map(() => Array(newDetailValueCount).fill("")));
  }, [item, rowCount]);

  // 计算CEMS法详细值的平均值
  const calculateCemsAvgFromDetails = (rowIndex) => {
    const rowValues = cemsDetailValues[rowIndex];
    if (!rowValues || !Array.isArray(rowValues)) return "";
    const validValues = rowValues.filter(v => v !== "");
    if (validValues.length === 0) return "";
    const sum = validValues.reduce((acc, val) => acc + Number(val), 0);
    return (sum / validValues.length).toFixed(2);
  };

  // 更新CEMS法详细值并自动计算平均值
  const updateCemsDetailValue = (rowIndex, colIndex, value) => {
    const newCemsDetailValues = [...cemsDetailValues];
    // 确保行存在，使用当前项目的详细值数量
    if (!newCemsDetailValues[rowIndex]) {
      newCemsDetailValues[rowIndex] = Array(getDetailValueCount(item)).fill("");
    }
    newCemsDetailValues[rowIndex][colIndex] = value;
    setCemsDetailValues(newCemsDetailValues);
    
    // 自动计算平均值并更新CEMS法值
    const avg = calculateCemsAvgFromDetails(rowIndex);
    const newCemsValues = [...cemsValues];
    newCemsValues[rowIndex] = avg;
    setCemsValues(newCemsValues);
  };

  // 计算相对准确度（使用新的统计方法）
  const calculateRelativeAccuracy = () => {
    // 检查输入是否完整（相对准确度需要所有数据）
    const allFilled = refValues.every(v => v !== "") && cemsValues.every(v => v !== "");
    if (!allFilled) return null;
    
    // 步骤1：计算每一行CEMS法-参比法，得到数据对差
    const differences = refValues.map((refVal, index) => {
      const ref = Number(refVal);
      const cems = Number(cemsValues[index]);
      return cems - ref;
    });
    
    // 计算数据对差平均值
    const diffAvg = differences.reduce((sum, diff) => sum + diff, 0) / differences.length;
    
    // 步骤2：每一行数据对差减去数据对差平均值得到对差比例
    const diffRatios = differences.map(diff => diff - diffAvg);
    
    // 步骤3：对差比例求平方得到对差方，所有行的对差方之和除以8再开平方根得到标准偏差
    const diffSquares = diffRatios.map(ratio => ratio * ratio);
    const sumOfSquares = diffSquares.reduce((sum, square) => sum + square, 0);
    const standardDeviation = Math.sqrt(sumOfSquares / 8);
    
    // 步骤4：置信系数 = 标准偏差 * 2.306 / 3
    const confidenceCoefficient = standardDeviation * 2.306 / 3;
    
    // 步骤5：相对准确度计算公式中的常数2.306改为置信系数
    const relativeAccuracy = ((Math.abs(Number(absErr)) + confidenceCoefficient) / Number(refAvg) * 100).toFixed(2);
    
    return {
      relativeAccuracy,
      confidenceCoefficient: confidenceCoefficient.toFixed(4),
      standardDeviation: standardDeviation.toFixed(4),
      diffAvg: diffAvg, // 不再这里格式化，而是在显示时处理
      diffAvgDisplay: diffAvg.toFixed(4) + "(四舍五入保留四位小数)",
      differences: differences.map(d => d.toFixed(2)),
      diffRatios: diffRatios.map(r => r.toFixed(4)),
      diffSquares: diffSquares.map(s => s.toFixed(4)),
      sumOfSquares: sumOfSquares.toFixed(4)
    };
  };

  // 平均值
  const refAvg = calcAvg(refValues);
  const cemsAvg = calcAvg(cemsValues);
  
  // 检查是否有至少一组数据
  const hasAtLeastOneGroup = refValues.some(v => v !== "") && cemsValues.some(v => v !== "");
  
  // 计算每一行的差值
  const calculateAbsoluteError = () => {
    if (!hasAtLeastOneGroup) return "";
    
    const differences = [];
    for (let i = 0; i < refValues.length; i++) {
      const refVal = refValues[i];
      const cemsVal = cemsValues[i];
      if (refVal !== "" && cemsVal !== "") {
        differences.push(Number(cemsVal) - Number(refVal));
      }
    }
    
    if (differences.length === 0) return "";
    const avgDifference = differences.reduce((sum, diff) => sum + diff, 0) / differences.length;
    return avgDifference.toFixed(2);
  };
  
  // 计算（只要有至少一组数据就可以计算）
  const absErr = calculateAbsoluteError();
  const relErr = (absErr !== "" && refAvg !== "" && Number(refAvg) !== 0) ? ((Number(absErr) / Number(refAvg)) * 100).toFixed(2) : "";
  
  // 使用新的相对准确度计算方法
  const accuracyResult = calculateRelativeAccuracy();
  const accu = accuracyResult ? accuracyResult.relativeAccuracy : "";

  // 达标判断
  const { result, reason } = getResultJudgement(item, refAvg, absErr, relErr, accu);

  // 检查输入是否完整（用于相对准确度计算）
  const allFilled = refValues.every(v => v !== "") && cemsValues.every(v => v !== "");
  
  // 检查是否有足够数据进行达标判断（至少一行数据）
  const hasEnoughDataForJudgement = hasAtLeastOneGroup && absErr !== "" && relErr !== "";

  return (
    <ErrorBoundary>
      <div style={{ padding: 24, maxWidth: 1200, margin: "0 auto" }}>
        {/* 检测项目与单位 */}
        <div style={{ display: "flex", alignItems: 'center', gap: 24, marginBottom: 16, flexWrap: 'wrap' }}>
          <div>
            <label>检测项目：</label>
            <select value={item} onChange={e => handleItemChange(e.target.value)}>
              {items.map(i => (
                <option key={i.value} value={i.value}>{i.label}</option>
              ))}
            </select>
          </div>
          <div>
            <label>单位：</label>
            <span>{getUnit(item)}</span>
          </div>
        </div>
        {/* 表格输入区 */}
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', background: '#fff', borderCollapse: 'collapse', marginBottom: 24 }} border={1}>
            <thead>
              <tr style={{ background: '#f9fafe' }}>
                <th style={{ width: 60 }}>序号</th>
                <th style={{ width: 120 }}>参比法</th>
                <th style={{ width: 120 }}>CEMS法</th>
                <th colSpan={detailValueCount} style={{ textAlign: 'center' }}>CEMS法详细值（自动计算平均值）</th>
              </tr>
              <tr style={{ background: '#f0f4ff' }}>
                <th></th>
                <th></th>
                <th></th>
                {Array.from({ length: detailValueCount }).map((_, j) => (
                  <th key={j} style={{ width: 80, fontSize: 12 }}>值{j + 1}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: rowCount }).map((_, i) => (
                <tr key={i}>
                  <td style={{ textAlign: 'center' }}>{i + 1}</td>
                  <td>
                    <input
                      type="number"
                      value={refValues[i]}
                      onChange={e => setRefValues(refValues.map((v, idx) => idx === i ? e.target.value : v))}
                      style={{ width: '90%', borderRadius: 8, padding: 5 }}
                      placeholder="手动输入"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      value={cemsValues[i]}
                      onChange={e => setCemsValues(cemsValues.map((v, idx) => idx === i ? e.target.value : v))}
                      style={{ width: '90%', borderRadius: 8, padding: 5 }}
                      placeholder="手动输入或自动计算"
                    />
                  </td>
                  {Array.from({ length: detailValueCount }).map((_, j) => (
                    <td key={j}>
                      <input
                        type="number"
                        value={cemsDetailValues[i] && cemsDetailValues[i][j] !== undefined ? cemsDetailValues[i][j] : ""}
                        onChange={e => updateCemsDetailValue(i, j, e.target.value)}
                        style={{ width: '90%', borderRadius: 8, padding: 5, fontSize: 12 }}
                        placeholder={`值${j + 1}`}
                      />
                    </td>
                  ))}
                </tr>
              ))}
              <tr style={{ background: '#f9fafe', fontWeight: 'bold' }}>
                <td style={{ textAlign: 'center' }}>平均值</td>
                <td>{refAvg}</td>
                <td>{cemsAvg}</td>
                <td colSpan={detailValueCount} style={{ textAlign: 'center', color: '#666' }}>
                  详细值平均值自动填入CEMS法列
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* 计算结果 */}
        <div style={{ display: 'flex', gap: 24, marginBottom: 16, flexWrap: 'wrap' }}>
          <div><b>绝对误差：</b>{absErr !== "" ? absErr : "-"}</div>
          <div><b>相对误差（%）：</b>{relErr !== "" ? relErr : "-"}</div>
          <div><b>相对准确度（%）：</b>{accu !== "" ? accu : "-"}</div>
        </div>
        {/* 达标情况 */}
        <div style={{ background: '#f9fafe', borderRadius: 10, padding: 20, marginTop: 16, fontSize: 16, boxShadow: '0 2px 8px #e5e9f2' }}>
          <div><b>达标情况：</b>{!hasEnoughDataForJudgement ? <span style={{ color: '#888' }}>请至少输入一行数据</span> : result}</div>
          {hasEnoughDataForJudgement && <div style={{ color: '#888', marginTop: 8 }}>{reason}</div>}
        </div>
        <FormulaDisplay title="公式与计算过程" defaultCollapsed={true}>
          <div><b>绝对误差计算公式：</b> E₁ = 每一行(CEMS法-参比法)的值的平均值</div>
          <div><b>相对误差计算公式：</b> E₂ = 绝对误差 / 参比法平均值 × 100</div>
          <div><b>相对准确度计算公式：</b> E₃ = (|绝对误差| + 置信系数) / 参比法平均值 × 100</div>
          {hasAtLeastOneGroup && (
            <div style={{ marginTop: 12, color: '#333', fontSize: 15 }}>
              <div>绝对误差计算过程：</div>
              {(() => {
                const differences = [];
                for (let i = 0; i < refValues.length; i++) {
                  const refVal = refValues[i];
                  const cemsVal = cemsValues[i];
                  if (refVal !== "" && cemsVal !== "") {
                    const diff = Number(cemsVal) - Number(refVal);
                    differences.push({ index: i + 1, ref: refVal, cems: cemsVal, diff: diff.toFixed(2) });
                  }
                }
                return (
                  <>
                    {differences.map((item, idx) => (
                      <div key={idx} style={{ marginLeft: 20, fontSize: 14 }}>
                        第{item.index}行：{item.cems} - {item.ref} = {item.diff}
                      </div>
                    ))}
                    <div>绝对误差 = ({differences.map(d => d.diff).join(' + ')}) / {differences.length} = {absErr}</div>
                  </>
                );
              })()}
              <div>相对误差计算过程：E₂ = {absErr} / {refAvg} × 100 = {relErr}</div>
              {accuracyResult && (
                <>
                  <div style={{ marginTop: 16, fontWeight: 'bold' }}>相对准确度详细计算过程：</div>
                  <div>步骤1：数据对差 = CEMS法 - 参比法</div>
                  {accuracyResult.differences.map((diff, index) => (
                    <div key={index} style={{ marginLeft: 20, fontSize: 14 }}>
                      第{index + 1}行：{cemsValues[index]} - {refValues[index]} = {diff}
                    </div>
                  ))}
                  <div>数据对差平均值：{accuracyResult.diffAvgDisplay}</div>
                  <div style={{ marginTop: 8 }}>步骤2：对差比例 = 数据对差 - 数据对差平均值</div>
                  {accuracyResult.diffRatios.map((ratio, index) => (
                    <div key={index} style={{ marginLeft: 20, fontSize: 14 }}>
                      第{index + 1}行：{accuracyResult.differences[index]} - {accuracyResult.diffAvgDisplay} = {ratio}
                    </div>
                  ))}
                  <div style={{ marginTop: 8 }}>步骤3：对差方 = 对差比例²</div>
                  {accuracyResult.diffSquares.map((square, index) => (
                    <div key={index} style={{ marginLeft: 20, fontSize: 14 }}>
                      第{index + 1}行：{accuracyResult.diffRatios[index]}² = {square}
                    </div>
                  ))}
                  <div>对差方之和：{accuracyResult.sumOfSquares}</div>
                  <div>标准偏差 = √(对差方之和 / 8) = √({accuracyResult.sumOfSquares} / 8) = {accuracyResult.standardDeviation}</div>
                  <div style={{ marginTop: 8 }}>步骤4：置信系数 = 标准偏差 × 2.306 / 3 = {accuracyResult.standardDeviation} × 2.306 / 3 = {accuracyResult.confidenceCoefficient}</div>
                  <div style={{ marginTop: 8 }}>步骤5：相对准确度 = (|{absErr}| + {accuracyResult.confidenceCoefficient}) / {refAvg} × 100 = {accu}</div>
                </>
              )}
            </div>
          )}
        </FormulaDisplay>
      </div>
    </ErrorBoundary>
  );
};

export default ComparisonCalculator; 